
import { Container } from "@/components/ui/container";
import { 
  ShieldCheck, 
  BarChart4, 
  Clock, 
  HandshakeIcon 
} from "lucide-react";

interface MetricCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const MetricCard = ({ icon, title, description }: MetricCardProps) => {
  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
      <div className="p-3 bg-purple-50 rounded-full w-fit mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-3 text-gray-900">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

export const ValueMetricsSection = () => {
  const metrics = [
    {
      icon: <ShieldCheck className="w-6 h-6 text-edgefi-purple" />,
      title: "Improved Security Posture",
      description: "Clear policies establish proper security practices across your organization, reducing risk and strengthening your overall security posture."
    },
    {
      icon: <BarChart4 className="w-6 h-6 text-edgefi-purple" />,
      title: "Compliance Readiness",
      description: "Well-documented policies demonstrate regulatory compliance and preparedness for audits and assessments."
    },
    {
      icon: <Clock className="w-6 h-6 text-edgefi-purple" />,
      title: "Efficiency Gains",
      description: "Standardized procedures eliminate guesswork, reduce response time, and create consistency in security operations."
    },
    {
      icon: <HandshakeIcon className="w-6 h-6 text-edgefi-purple" />,
      title: "Organizational Alignment",
      description: "Policies create shared understanding and alignment between IT, security, and business objectives."
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <Container>
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 text-gray-900">Value of Strong Policies & Procedures</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Well-developed policies and procedures deliver measurable benefits to your organization's security program and business operations.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics.map((metric, index) => (
            <MetricCard 
              key={index}
              icon={metric.icon}
              title={metric.title}
              description={metric.description}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};
